import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';

import {
    upsertLab,
    fetchLabDetails,
    clearLabDetails,
    fetchLabInstructions,
    uploadLabKeys,
    fetchProducts,
    deleteLab,
} from '../../actions/lab-actions';

import Lab from './lab';

const mapStateToProps = ({ appReducer, labReducer, eventReducer }) => ({
    appReducer,
    labReducer,
    eventReducer,
});

const mapDispatchToProps = (dispatch) =>
    bindActionCreators(
        {
            upsertLab,
            fetchLabDetails,
            clearLabDetails,
            fetchLabInstructions,
            uploadLabKeys,
            fetchProducts,
            deleteLab,
        },
        dispatch,
    );

export default connect(mapStateToProps, mapDispatchToProps)(Lab);
